<template>
	<div class="b-coupon">
		<h5 class="b-coupon__title" v-html="loc.SOA_SUM_COUPON_DEFAULT"></h5>
		<div class="b-coupon__list">
			<div class="b-coupon__inputWrap">
				<input class="b-coupon__input" type="text" name="COUPON" v-model="couponValue" @change="enterCoupon" @blur="enterCoupon" :placeholder="loc.SOA_SUM_COUPON_USE_DEFAULT">
				<button class="b-coupon__btn b-btn_roundOutline" @click.prevent.stop="enterCoupon" v-html="loc.SOA_SUM_COUPON_APPLY_TITLE"></button>
			</div>
			<div class="b-coupon__item bx-soa-coupon-item-danger"
			     v-if="(!phone && useCoupon && couponList.length > 0)">
				<span class="b-coupon__itemName" >Необходимо указать номер телефона</span>
			</div>
			<div class="b-coupon__item bx-soa-coupon-item-danger"
			     v-if="(warning !== '')">
				<span class="b-coupon__itemName" >{{ warning }}</span>
			</div>
			<div class="b-coupon__item"
			     :class="'bx-soa-coupon-item-' + couponClass[coupon.JS_STATUS]"
			     v-for="coupon in couponList">
				<span class="b-coupon__itemName" v-html="coupon.COUPON" :title="coupon.CHECK_CODE_TEXT[0]"></span>
				<span class="b-coupon__itemRemove bx-soa-coupon-remove" @click="removeCoupon(coupon.COUPON)"></span>
			</div>
		</div>
	</div>
</template>

<script>
	import {Events, ServerMethod} from "../mixins/constant";
	import {Vue} from "ui.vue";

	export default {
		name: "Coupon",
		props: {
			couponList: {
				type: [Array, Object],
				default: () => {
				}
			},
			phone: {
				type: [String],
				default: () => {
				}
			},
			warning: {
				type: [String],
				default: () => {
				}
			}
		},
		data() {
			return {
				couponClass: {
					"APPLIED": "success",
					"BAD": "danger",
					"ENTERED": "used"
				},
				couponValue: "",
				useCoupon: true,
			}
		},
		computed: {
			loc() {
				return Vue.getFilteredPhrases("SOA_SUM_COUPON_");
			},
		},
		methods: {
			enterCoupon: function () {
				if (!this.couponValue || (!this.phone && !this.couponValue)) {
					if(!this.phone && !this.couponValue) {
						this.useCoupon = true;
					}
					return;
				}

				Vue.event.$emit(Events.REFRESH, {action: ServerMethod.ENTER_COUPON, data: {coupon: this.couponValue}});
				this.couponValue = "";
			},
			removeCoupon: function (coupon) {
				Vue.event.$emit(Events.REFRESH, {action: ServerMethod.REMOVE_COUPON, data: {coupon: coupon}});
			},
			removeUseCoupon: function () {
				this.useCoupon = false;
			}
		}
	}
// test script
</script>